import ProductLineItemService from "@/services/ProductLineItemService";

async function checkProduct(ids){
    return await ProductLineItemService.wiadvanceOpptyRequiredFieldCheck({oppty:ids})
    .then((res)=>{
        return res.data
    })
}

export default checkProduct;